<template>
    <transition name="fade">
        <div v-if="modalVisible">
            <div class="modal-mask">
                <div class="modal-wrapper">
                    <div class="modal-dialog modal-lg">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h3>{{ __('generate_balance')}}
                                    <button-open-help-modal :helpName="helpName" :inExtraDiv="false" :color="'dark'"/>
                                </h3>
                                <button type="button" class="close" @click="hideModal"><span aria-hidden="true">&times;</span><span
                                        class="sr-only">Close</span></button>
                            </div>

                            <div class="modal-body">
                                <div class="form-group row m-b-sm">
                                    <div class="col-md-2">
                                        <label><strong>{{ __('date') }}*</strong></label>
                                        <input type="text" class="form-control" :value="today" disabled>
                                    </div>

                                    <div class="col-md-3">
                                        <label><strong>{{ __('created_by') }}*</strong></label>
                                        <input type="text" class="form-control" :value="userInfo.username" disabled>
                                    </div>
                                    <div class="col-md-2">
                                        <label><strong>{{ __('amount') }}*</strong></label>
                                        <input type="text" class="form-control" :value="modalData.amount" disabled name="document_amount">
                                    </div>

                                    <div class="col-md-1">
                                        <label><strong>{{ __('currency') }}*</strong></label>
                                        <input type="text" class="form-control" :value="modalData.currency" disabled>
                                    </div>
                                    <div class="col-md-4" :class="{ 'has-error': hasError('description') }">
                                        <label><strong class="text-capitalize">{{ __('description') }}*</strong></label>
                                        <input type="text" class="form-control" v-model="description">
                                        <span v-show="hasError('description')" class="help-block text-danger">{{ getError('description') }}</span>
                                    </div>
                                </div>
                                <div class="modal-footer connect-with-modal-footer">
                                    <button type="button" class="btn btn-white" @click="hideModal">{{ __('cancel') }}</button>
                                    <button type="button" class="btn btn-primary" @click="sendModalData" :disabled="submitted">{{ __('save') }}</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import events from './../../services/Events.js'
    import actions from './../../vuex/action_types.js'
    import mutations from './../../vuex/mutation_types.js'
    import ButtonOpenHelpModal from '../../components/help/ButtonOpenHelpModal.vue'

    export default {
        name: 'modal-generate-balance',
        components: { ButtonOpenHelpModal },
        data: function () {
            return {
                modalVisible: null,
                submitted: false,
                hasErrors: false,
                description: '',
                helpName: 'ZRB-006'
            }
        },
        methods: {
            showModal: function() {
                this.$store.commit(mutations.SET_MODAL_GENERATE_BALANCE_ERRORS, {});
                this.modalVisible = true
                setTimeout(() => {
                    $('.modal-dialog').draggable({
                        handle: ".modal-header"

                    });
                }, 1000)
            },
            hideModal: function() {
                let input_data = {
                    operations: this.$store.getters.getSelectedOperations,
                    documents: this.$store.getters.getSelectedDocuments
                };
                this.modalVisible = false;
                this.$store.dispatch(actions.DELETE_LOCKS, input_data)
            },
            hasError: function(field) {
                return this.errors.hasOwnProperty(field)
                    && Array.isArray(this.errors[field])
                    && this.errors[field].length >= 1;

            },
            getError: function(field) {
                return this.hasError(field) ? this.errors[field][0] : ''
            },
            sendModalData: function() {
                this.submitted = true;
                events.$emit('modalGenerateBalance:saving');
                this.$store.dispatch(actions.MODAL_GENERATE_BALANCE_SAVE, { url: this.modalData.balance_url, description: this.description })
                    .then(response => {
                        events.$emit('modalGenerateBalance:saved');
                        this.$emit('save');
                        this.modalVisible = false;
                        this.submitted = false;
                        this.description = '';
                    })
                    .catch(error => {
                        if(error.response.status === 422) {
                            this.$store.commit(mutations.SET_MODAL_GENERATE_BALANCE_ERRORS, error.response.data.errors);
                        } else {
                            console.log(error.response.data.message);
                            toastr['error'](this.__('failed_to_perform_action')).css('border', '0px');
                        }
                        events.$emit('modalGenerateBalance:error');
                        this.submitted = false;
                    })
            }
        },
        props: [ ],
        computed: {
            modalData() { return this.$store.getters.getModalGenerateBalanceData },
            userInfo() { return this.$store.getters.getUserInfo },
            today() { return this.$store.getters.getServerInfo.instanceDate },
            errors() { return this.$store.getters.getModalGenerateBalanceErrors },
        },
        mounted: function() {
            events.$on('showGenerateBalanceModal', this.showModal);
            events.$on('hideGenerateBalanceModal', this.hideModal);
        },
    }

</script>

<style scoped>
    .modal-mask {
        position: fixed;
        z-index: 2049;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }

    .modal-header h3 {
        margin-left:auto;
        margin-right:auto;
        width: 100%;
    }
</style>
